import type { TransferMethod, TransferMethodsMap } from './transferMethods.types';

export const buildTransferMethodsMap = (transferMethods: TransferMethod[] = []): TransferMethodsMap => {
    const titles = new Set<string>();

    for (const method of transferMethods) {
        for (const row of method.method_row ?? []) {
            if (row?.row_title) {
                titles.add(row.row_title);
            }
        }
    }

    const result: TransferMethodsMap = {};

    for (const title of titles) {
        result[title] = transferMethods.map((method) => method.method_row?.find((row) => row.row_title === title)?.row_text ?? null);
    }

    return result;
};
